import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-bs-target"]
const _hoisted_2 = { class: "card-body d-flex flex-column flex-center text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-white fw-bolder text-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    "data-bs-toggle": "modal",
    "data-bs-target": `#${_ctx.modalId}`,
    class: "card border-0 shadow-none min-h-200px mb-7",
    style: _normalizeStyle(`background-color:${_ctx.color}`)
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "mw-100 h-100px mb-7 mx-auto",
        src: _ctx.image
      }, null, 8, _hoisted_3),
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.buttonText), 1)
    ])
  ], 12, _hoisted_1))
}